module.exports = __webpack_public_path__ + "static/media/level3.10c70c99.svg";